import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import {NestedTreeControl} from "@angular/cdk/tree";
import {Category} from "../../../models/category";
import {MatTreeNestedDataSource} from "@angular/material/tree";
import {CategoryService} from "../../../services/category.service";
import {AlertService} from "../../../services";

@Component({
    selector     : 'customer-resources-sidebar',
    templateUrl  : './resources-sidebar.component.html',
    styleUrls    : ['./resources-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class CustomerResourcesSidebarComponent implements OnInit, OnDestroy
{
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    treeControl = new NestedTreeControl<Category>(node => node.children);
    dataSource = new MatTreeNestedDataSource<Category>();
    categories: Category[];
    loadingIndicator: boolean;
    @Output() filteredCategory = new EventEmitter<string>();

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router,
        private categoryService: CategoryService,
        private alertService: AlertService,
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.dataSource.data = [];
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.categoryService.getAllMainByType('resource').subscribe((res: any[]) => {
            this.categories = res;
            this.dataSource.data = res;
            this.loadingIndicator = false;
        }, error => {
            this.alertService.error(error);
        })
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New customer
     */
    newCustomer(): void
    {
        this._router.navigate(['/customers/new']).then(() => {

        });
    }

    hasChild = (_: number, node: Category) => !!node.children && node.children.length > 0;

    filterListByCategory(id: string): void {
        this.filteredCategory.emit(id);
    }
}
